export const STRIPE_ROLES = {
	PAYING_USER: 'payingUser',
};

export const ACCESS_TYPES = {
	LIFETIME: 'lifetime',
	SUBSCRIPTION_MONTHLY: 'subscription_monthly',
	SUBSCRIPTION_YEARLY: 'subscription_yearly',
	NONE: 'none',
};

export const INTERVALS = {
	MONTH: 'month',
	YEAR: 'year',
};

export const IMAGETYPE = {
	SINGLE: 'single',
	DOUBLE: 'double',
};

export const ERROR_CODES = {
	POPUP_BLOCKED: 'POPUP_BLOCKED',
	DOWNLOAD_SUCCESS: 'DOWNLOAD_SUCCESS',
};

export const ANGLE_LINES = {
	NONE: 'None',
	TOPONLY: 'Top Only',
	BOTTOMONLY: 'Bottom Only',
	TOPANDBOTTOM: 'Top and Bottom',
};

export const BOOK_INFO_DEFAULTS = {
	MAX_HEIGHTMM: 280,
	MAX_LAST_ODD_PAGE: 2000,
	MAX_HEIGHTINCH: 11,
	MAX_EXTRA_PAGES: 50,
};

export const MEASUREMENT_UNIT = {
	cm: 'cm',
	inch: 'inch',
};

export const MEASUREMENT_UNITS = [
	{
		value: MEASUREMENT_UNIT.cm,
		label: 'cm',
	},
	{
		value: MEASUREMENT_UNIT.inch,
		label: 'inches',
	},
];

export const FRACTIONS = [
	{
		value: '0',
		label: '-',
	},
	{
		value: '0.125',
		label: '1/8',
	},
	{
		value: '0.25',
		label: '1/4',
	},
	{
		value: '0.375',
		label: '3/8',
	},
	{
		value: '0.5',
		label: '1/2',
	},
	{
		value: '0.625',
		label: '5/8',
	},
	{
		value: '0.75',
		label: '3/4',
	},
	{
		value: '0.875',
		label: '7/8',
	},
];

export const STEP = {
	BrowseImage: 0,
	BookDetails: 1,
	PrintPattern: 2,
};

export const PRICE_TYPES = {
	SUBSCRIPTION: 'SUBSCRIPTION',
	ONETIME: 'ONETIME',
	LIBRARY: 'LIBRARY',
};

// Free Price object when no price is found
export const FREE_PRICE = {
	id: 'free',
	data: {
		unit_amount: 0,
		interval: '',
		product: 'basic-plan',
	},
};

const _storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_STORAGE_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${_storageBucket}/o`;
export const FIREBASE_STORAGE_SINGLE_PATTERNS_URL = `${FIREBASE_STORAGE_BASE_URL}/singlePatterns%2F`;
export const FIREBASE_STORAGE_PATTERN_LIBRARY_URL = `${FIREBASE_STORAGE_BASE_URL}/patternLibrary%2F`;

export const ONETIME_PRODUCT_ID = process.env.REACT_APP_ONETIME_PRODUCT_ID;
export const PRODUCT_ID_SINGLE = process.env.REACT_APP_PRODUCT_ID_SINGLE;
export const PRODUCT_ID_SUBSCRIPTION =
	process.env.REACT_APP_PRODUCT_ID_SUBSCRIPTION;
export const PRODUCT_ID_LIBRARY = process.env.REACT_APP_PRODUCT_ID_LIBRARY;

export const FIREBASE_STORAGE_TEMP_IMAGES_PATH = 'tempImages';

export const FACEBOOK_COMMUNITY_URL =
	'https://www.facebook.com/share/g/15LzBAKnYB/';

export const ROUTES = {
	ABOUT: '/About',
	PATTERN_MAKER: '/PatternMaker',
	PATTERN_LIBRARY: '/PatternLibrary',
	MY_PATTERNS: '/MyPatterns',
	SINGLE_PATTERN: '/sp',
	PATTERN_RESULT: '/pr',
};
